var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row d-flex flex-row px-3" },
    [
      _c("h5", { staticClass: "bold" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("campaigns.actions.verifyEmail")) + "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "justified progress-text mb-0" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$tc("campaigns.messages.verifyEmail.0")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("i", [
          _vm._v(
            " " + _vm._s(_vm.$tc("campaigns.messages.verifyEmail.2")) + " "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showNotVerifiedMssg
          ? _c("p", { staticClass: "justified resend-text text-danger" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("campaigns.messages.verifyEmail.1")) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }